import * as React from 'react';
import {ApplicationState} from "../../store";
import {Contact, ContactDescriptor} from '../../models/Contact';
import {ListItem, Avatar, List, ListSubheader, TextField, ListItemText, ListItemAvatar, Collapse,
    ListItemSecondaryAction, IconButton} from '@material-ui/core';
import {Utility} from '../../core/Utility';
import {actionSetTabState} from '../../store/tabs/actions';
import {connect} from 'react-redux';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import {compose} from 'redux';
import {withStyles} from '@material-ui/core/styles';
import {GlobalStyles} from "../../materialui/style";
import SaveIcon from "@material-ui/icons/Save"
import {actionContactSave, actionContactDelete} from '../../store/customers/actions';
import {DeleteConfirmation} from "../components/DeleteConfirmation";
import {t} from "../../core/localization";
import {Validator} from "../../core/Validator";

export interface ContactsFormProps {
	item?: any
    state?: any
    classes: any
}

export interface ContactsFormState {
    isDeleteConfirmationDialogOpen: boolean;
    positionOfItemToDelete?: number;
	validation: any;
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
	};
}

class ContactsForm extends React.Component<ContactsFormProps, ContactsFormState> {

    constructor(props: ContactsFormProps){
        super(props);
        this.state = {isDeleteConfirmationDialogOpen: false, validation: { valid: true, fields: [] }}
    }

    componentWillReceiveProps(nextProps: ContactsFormProps) {
    }

    componentDidMount() {
	}

    onSelectChange(value: number, listItem: any): void{

        let item: any = this.props.item
        let tabState = this.props.state

        if (!tabState['item']) tabState['item'] = {...item}
        let selectedContactNumber = tabState['item']['selectedContactNumber']

        if(selectedContactNumber === value)
            tabState['item']['selectedContactNumber'] = undefined
        else
            tabState['item']['selectedContactNumber'] = value

		actionSetTabState(tabState)
    }

    handleItemTextInputChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>, key: string) {
		let item: any = this.props.item
        let tabState = this.props.state

        if (!tabState['item']) tabState['item'] = {...item}

        let selectedContactNumber = tabState['item']['selectedContactNumber']
        if(selectedContactNumber !== undefined)
		    tabState['item']['contacts'][selectedContactNumber][key] = e.target.value
		actionSetTabState(tabState)
    }

    getItemFromTabState (key?: string) {
		let tabState = this.props.state
		if (tabState['item']) {
			if (!key) return tabState['item']
			else if (!Utility.isNullOrUndefined(tabState['item'][key])) return tabState['item'][key]
		}
		if (!key) return this.props.item
		else return this.props.item[key]
	}

    getContactFromTabState (key?: string, position?: number) {
        let tabState = this.props.state
		if (tabState['item']) {
			if (!key) return tabState['item']
			else if (!Utility.isNullOrUndefined(tabState['item']['contacts'][position][key])) return tabState['item']['contacts'][position][key]
        }

		if (!key) return this.props.item
        else if(this.props.item['contacts'] && this.props.item['contacts'][position])
            return this.props.item['contacts'][position][key]
    }

    onSaveContact(value: number): void{

		let item = this.getItemFromTabState()
		let contact = item.contacts[value]

		let validation: any = Validator.validateItemWithErrorTypes(contact, ContactDescriptor)

		if (validation.valid) {
			actionContactSave(contact, value)
		}

		this.setState({ ...this.state, validation: validation });
    }

    onToggleDeleteConfirmationModal(){

		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: !this.state.isDeleteConfirmationDialogOpen, positionOfItemToDelete: undefined});
    }

    openDeleteConfirmationModal(position: number) {
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: true, positionOfItemToDelete: position});
	}

	onDeleteConfirmClick(){
        let item = this.getItemFromTabState()
        if(this.state.positionOfItemToDelete !== undefined){

            let contact = item.contacts[this.state.positionOfItemToDelete]
            if(contact && contact.id)
                actionContactDelete(contact)

            item.contacts.splice(this.state.positionOfItemToDelete, 1)
            let tabState = this.props.state

            tabState['item'] = item
            this.onToggleDeleteConfirmationModal()
            actionSetTabState(tabState)
        }
	}

    render(): React.ReactNode{
        return <div>
            {this.renderContacts()}
            {this.renderDeleteConfirmationDialog()}
        </div>
    }

    renderDeleteConfirmationDialog(): React.ReactNode {
		return <DeleteConfirmation
			isOpen={this.state.isDeleteConfirmationDialogOpen}
			onDeleteConfirm={() => this.onDeleteConfirmClick()}
			onToggleModal={() => this.onToggleDeleteConfirmationModal()}
		/>
	}

    renderContacts(): React.ReactNode{
		let classes = this.props.classes

        let item = this.getItemFromTabState()
		var contacts: Contact[] = item.contacts,
            listItems = [];
        if(contacts){

            for (var i=0; i<contacts.length; i++) {
                var contact = contacts[i],
                    selected = item['selectedContactNumber'] === i,
                    firstLetter = contact.title ? contact.title.charAt(0) : '';

                listItems.push(<div key={String(i)}>
                    <ListItem
                        key={String(i)}
                        onClick={this.onSelectChange.bind(this, i)}
                        className={classes.rootContacts}
                        selected={selected}
                    >
                        <ListItemAvatar>
                            <Avatar>{firstLetter}</Avatar>
                        </ListItemAvatar>

                        <ListItemText primary={contact.title} />

                        <ListItemSecondaryAction>

                            <IconButton onClick={this.onSaveContact.bind(this, i)} edge="end" aria-label="delete">
                                <SaveIcon />
                            </IconButton>

                            <IconButton onClick={this.openDeleteConfirmationModal.bind(this, i)} edge="end" aria-label="delete">
                                <DeleteIcon />
                            </IconButton>

                            <IconButton onClick={this.onSelectChange.bind(this, i)} edge="end" aria-label="delete">
                                {selected ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>

                        </ListItemSecondaryAction>

                    </ListItem>
                    <Collapse in={selected} timeout="auto" unmountOnExit>

                    <List disablePadding>
                        <ListItem key="title" className={classes.nestedContacts}>
                            <TextField
                                label={t.Name}
                                value={Utility.formatString(this.getContactFromTabState('title', i))}
                                onChange={(e) => {this.handleItemTextInputChange(e, 'title')}}
                                margin="normal"
                                fullWidth
                                required={true}
								error={Validator.displayFormErrors(this.state.validation.fields, 'title').show}
								helperText={Validator.displayFormErrors(this.state.validation.fields, 'title').message}
                            />
                        </ListItem>
                        <ListItem key="email" className={classes.nestedContacts}>
                            <TextField
                                label={t.Email}
                                value={Utility.formatString(this.getContactFromTabState('email', i))}
                                onChange={(e) => {this.handleItemTextInputChange(e, 'email')}}
                                margin="normal"
                                fullWidth
								required={true}
								error={Validator.displayFormErrors(this.state.validation.fields, 'email').show}
								helperText={Validator.displayFormErrors(this.state.validation.fields, 'email').message}
                            />
                        </ListItem>
                        <ListItem key="phone" className={classes.nestedContacts}>
                            <TextField
                                label={t.Phone}
                                value={Utility.formatString(this.getContactFromTabState('phone', i))}
                                onChange={(e) => {this.handleItemTextInputChange(e, 'phone')}}
                                margin="normal"
                                fullWidth
								required={true}
								error={Validator.displayFormErrors(this.state.validation.fields, 'phone').show}
								helperText={Validator.displayFormErrors(this.state.validation.fields, 'phone').message}
                            />
                        </ListItem>
                    </List>
                </Collapse>
                </div>
                );
            }
        }
		return <List>
					<ListSubheader>{t.Contacts}</ListSubheader>
					{listItems}
			</List>
    }
}

export default compose(
	connect(mapStateToProps),
	withStyles(GlobalStyles)
)(ContactsForm);
